<template>
    <div class="money-log">
        <div class="bread-crumbs">
            <div class="crumbs-item" @click="onBackAC">资产中心</div>
            <Icon type="ios-arrow-forward" class="crumbs-icon" size="14" />
            <div class="crumbs-item active">{{ logType == 1 ? '支付账户明细' : '店铺账户明细' }}</div>
        </div>
        <template v-if="logType == 1">
            <div class="user-balance">
                <div class="balance-container">
                    <div class="balance-top">
                        <div class="withdrawal-log" @click="onShowWithdrawLog">提现记录</div>
                        <div class="balance-icon"></div>
                        <div class="balance-info">
                            <div class="info-title">账户余额</div>
                            <div class="info-balance-wrap">
                                <div class="info-price">{{shopInfo.total_balance | price_format}}</div>
                                <div class="btn-box">
                                    <div class="withdrawal-btn" @click="onWithdraw(1)">提现</div>
                                    <div class="charge-btn" @click="show_charge_pop=true">充值</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="filter-search-container">
                        <div class="filter-box">
                            <div class="filter-label">账户明细</div>
                            <div v-for="(item,index) in filter_list" :key="index" :class="['filter-item',{active:filter_form.type === item.value}]" @click="onTypeChange(item.value)">{{item.name}}</div>
                        </div>
                        <div class="search-box">
                            
                            <Dropdown class="search-time-box" @on-click="onTimeFilter">
                                <div class="time-dropdown">
                                    <div class="time-value">{{ current_time_filter }}</div>
                                    <Icon type="ios-arrow-down" class="arrow-down-icon" />
                                </div>
                                <DropdownMenu slot="list">
                                    <DropdownItem v-for="(item,index) in time_filter" :key="index" :name="item.value">{{item.name}}</DropdownItem>
                                </DropdownMenu>
                            </Dropdown>
                            
                            <form class="search-keyword-box" @submit.prevent="onSearchKeyword">
                                <Icon type="ios-search" class="search-icon" />
                                <input type="text" class="search-input" v-model="filter_form.keyword" placeholder="搜索账单" />
                            </form>
                        </div>
                    </div>
                    <table>
                        <thead>
                            <tr>
                                <th>日期</th>
                                <th>变动说明</th>
                                <!-- <th>类别</th> -->
                                <th>金额(元)</th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-if="list.length>0">
                                <tr v-for="(item,index) in list" :key="index">
                                    <td>{{item.create_time}}</td>
                                    <td>
                                        <div>{{ item.description }}</div>
                                    </td>
                                    <!-- <td>
                                        <div class="order-info">
                                            {{ item.type_text }}
                                        </div>
                                    </td> -->
                                    <td>
                                        <div :class="['price-box',{'income':Number(item.amount) > 0,'pay-out':Number(item.amount) < 0}]">{{ item.amount | price_format }}</div>
                                    </td>
                                </tr>
                            </template>
                            <template v-else>
                                <tr>
                                    <td colspan="3" align="center">暂无数据</td>
                                </tr>
                            </template>
                        </tbody>
                    </table>
                    <div class="pagination-container">
                        <Page :total="total_count" :current="filter_form.page" :page-size="filter_form.limit" prev-text="上一页" next-text="下一页" @on-change="onPageChange"></Page>
                    </div>
                </div>
            </div>
        </template>
        <template v-else>
            <div class="user-balance">
                <div class="balance-container">
                    <div class="balance-top">
                        <div class="withdrawal-log" @click="onShowWithdrawLog">提现记录</div>
                        <div class="balance-icon"></div>
                        <div class="balance-info-box">
                            <div class="balance-item">
                                <div class="info-title">可提现金额</div>
                                <div class="info-balance-wrap">
                                    <div class="info-price">{{assets_info.withdrawable_money | price_format}}</div>
                                </div>
                            </div>
                            <div class="balance-item">
                                <div class="info-title">总金额</div>
                                <div class="info-balance-wrap">
                                    <div class="info-price">{{assets_info.shop_total_asset | price_format}}</div>
                                </div>
                            </div>
                            <div class="balance-item">
                                <div class="info-title">待结算金额</div>
                                <div class="info-balance-wrap">
                                    <div class="info-price">{{assets_info.shop_unsettle_money | price_format}}</div>
                                    <div class="btn-box">
                                        <div class="withdrawal-btn" @click="onWithdraw(2)">提现</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="filter-search-container">
                        <div class="filter-box">
                            <div class="filter-label">账户明细</div>
                            <div v-for="(item,index) in filter_list" :key="index" :class="['filter-item',{active:filter_form.type === item.value}]" @click="onTypeChange(item.value)">{{item.name}}</div>
                        </div>
                        <div class="search-box">
                            
                            <Dropdown class="search-time-box" @on-click="onTimeFilter">
                                <div class="time-dropdown">
                                    <div class="time-value">{{ current_time_filter }}</div>
                                    <Icon type="ios-arrow-down" class="arrow-down-icon" />
                                </div>
                                <DropdownMenu slot="list">
                                    <DropdownItem v-for="(item,index) in time_filter" :key="index" :name="item.value">{{item.name}}</DropdownItem>
                                </DropdownMenu>
                            </Dropdown>
                            
                            <form class="search-keyword-box" @submit.prevent="onSearchKeyword">
                                <Icon type="ios-search" class="search-icon" />
                                <input type="text" class="search-input" v-model="filter_form.keyword" placeholder="搜索账单" />
                            </form>
                        </div>
                    </div>
                    <table>
                        <thead>
                            <tr>
                                <th>日期</th>
                                <th>变动说明</th>
                                <!-- <th>类别</th> -->
                                <th>金额(元)</th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-if="list.length>0">
                                <tr v-for="(item,index) in list" :key="index">
                                    <td>{{item.create_time}}</td>
                                    <td>
                                        <div>{{ item.description }}</div>
                                    </td>
                                    <!-- <td>
                                        <div class="order-info">
                                            {{ item.type_text }}
                                        </div>
                                    </td> -->
                                    <td>
                                        <div :class="['price-box',{'income':Number(item.amount) > 0,'pay-out':Number(item.amount) < 0}]">{{ item.amount | price_format }}</div>
                                    </td>
                                </tr>
                            </template>
                            <template v-else>
                                <tr>
                                    <td colspan="3" align="center">暂无数据</td>
                                </tr>
                            </template>
                        </tbody>
                    </table>
                    <div class="pagination-container">
                        <Page :total="total_count" :current="filter_form.page" :page-size="filter_form.limit" prev-text="上一页" next-text="下一页" @on-change="onPageChange"></Page>
                    </div>
                </div>
            </div>
        </template>
        <balance-charge v-if="show_charge_pop" @close-charge-pop="()=>show_charge_pop=false" @on-charge-success="onChargeSuccess"></balance-charge>
        <charge-success v-if="show_charge_success" @close-charge-success="()=>show_charge_success=false" :amount="temp_charge_amount"></charge-success>
    </div>
</template>
<script>
import { getBalanceLog, shopAccountBalanceLog, shopAssetsInfo } from '@/api/index';
import BalanceCharge from '@/components/BalanceCharge';
import ChargeSuccess from '@/components/ChargeSuccess';
import { mapState } from 'vuex';
export default{
    name:"MoneyLog",
    props:{
        logType:{
            type:[String,Number],
            default:1
        }
    },
    components:{
        BalanceCharge,
        ChargeSuccess
    },
    data(){
        return{
            filter_list:[
                {name:'全部',value:'-1'},
                {name:'支出',value:'1'},
                {name:'收入',value:'2'},
            ],
            time_filter:[
                {name:'全部时间',value:''},
                {name:'1个月',value:'1'},
                {name:'3个月',value:'3'},
                {name:'6个月',value:'6'},
                {name:'1年',value:'12'},
                {name:'1年以上',value:'12+'}
            ],
            filter_form:{
                type:'-1',
                keyword:"",
                page:1,
                limit:10,
                time_range:'',
                money_type:0
            },
            show_charge_pop:false,
            show_charge_success:false,
            temp_charge_amount:'',
            list:[],
            total_count:0,
            assets_info:{}
        }
    },
    computed:{
        ...mapState({
            userInfo:state=>state.userInfo,
            shopInfo:state=>state.shopInfo
        }),
        current_time_filter(){
            const {filter_form,time_filter} = this;
            return time_filter.filter((item)=>item.value === filter_form.time_range)[0].name;
        },
    },
    watch:{
        logType:{
            async handler(news,olds){
                if(news == 1){
                    await this.onGetBalanceLog();
                }else{
                    await this.onGetShopAccountBalanceLog();
                }
            },
            deep:true
        }
    },
    async mounted(){
        await this.$store.dispatch('getUser');
        await this.$store.dispatch('getShopInfo');
        if(this.logType == 1){
           await this.onGetBalanceLog();
        }else{
            await this.onGetShopAccountBalanceLog();
        }
        this.onGetShopAssetsInfo();
    },
    methods:{
        onShowWithdrawLog(){
            this.$emit('show-withdraw-log');
        },
        onWithdraw(type){
            this.$emit('show-withdraw',{type});
        },
        async onGetShopAssetsInfo(){
            try{
                const {code,msg,data} = await shopAssetsInfo();
                if(code>0){
                    this.$layer.msg(msg);
                    return;
                }
                console.log('data',data);
                this.assets_info = data;
            }catch(e){
                console.log('err-shop-assets-info',e);
                this.$layer.msg(e.msg);
            }
        },
        async onGetShopAccountBalanceLog(){
            try{
                console.log('filter-form',this.filter_form);
                const {code,msg,data} = await shopAccountBalanceLog(this.filter_form);
                if(code>0){
                    this.$layer.msg(msg);
                    return;
                }
                console.log('data',data);
                this.list = data.list;
                this.total_count = data.count;
            }catch(e){
                console.log('err-account-balance-log',e);
                this.$layer.msg(e.msg);
            }
        },
        onSearchKeyword(){
            console.log('on-search-keyword');
            this.filter_form.page = 1;
            if(this.logType == 1){
                this.onGetBalanceLog();
            }else{
                this.onGetShopAccountBalanceLog();
            }
        },
        onTypeChange(type){
            this.filter_form.page = 1;
            this.filter_form.type = type;
            let money_type = 0;
            switch(Number(type)){
                case 1:
                    money_type = -1;
                    break;
                case 2:
                    money_type = 1;
                    break;
            }
            // this.filter_form.money_type = money_type;
            this.$set(this.filter_form,'money_type',money_type);
            if(this.logType == 1){
                this.onGetBalanceLog();
            }else{
                this.onGetShopAccountBalanceLog();
            }
        },
        async onGetBalanceLog(){
            try{
                const {data} = await getBalanceLog(this.filter_form);
                console.log('data',data);
                this.total_count = data.count;
                this.list = data.list;
            }catch(e){
                console.log('err-balance-log',e);
            }
        },
        onPageChange(e){
            console.log('page_change',e);
            this.filter_form.page = e;
            if(this.logType == 1){
                this.onGetBalanceLog();
            }else{
                this.onGetShopAccountBalanceLog();
            }
        },
        onChargeSuccess({amount}){
            console.log('on-charge-success',amount);
            this.temp_charge_amount = amount
            this.show_charge_pop = false;
            this.show_charge_success = true;
        },
        onTimeFilter(time){
            console.log('time',time);
            this.filter_form.page = 1;
            this.filter_form.time_range = time;
            // this.onGetBalanceLog();
            if(this.logType == 1){
                this.onGetBalanceLog();
            }else{
                this.onGetShopAccountBalanceLog();
            }
        },
        onBackAC(){
            this.$emit('show-asset-center');
        }
    }
}
</script>
<style lang="scss" scoped>
.money-log{
    width:100%;
    display:flex;
    flex-direction:column;
    background:#ffffff;
    padding:30px;
    .bread-crumbs{
        display:flex;
        align-items:center;
        column-gap:8px;
        padding-bottom:22px;
        border-bottom:1px solid #d6d6d6;
        .crumbs-item{
            color:#999;
            font-size:14px;
            cursor:pointer;
            &:hover, &.active{
                color:#333;
            }
        }
    }
    .user-balance{
        width:100%;
        // min-height:100vh;
        display:flex;
        flex-direction:column;
        .balance-container{
            padding:40px;
            width:100%;
            flex:1;
            background:#ffffff;
            display:flex;
            flex-direction:column;
            .balance-top{
                width:100%;
                height:150px;
                border-radius:20px;
                background:#fff7f7;
                display:flex;
                align-items:center;
                position:relative;
                column-gap:129px;
                .balance-icon{
                    position:absolute;
                    left:0;
                    bottom:0;
                    width:128px;
                    height:114px;
                    // ../../../assets/images/icon-balance-detail.png
                    background:url('../../../../assets/images/icon-balance-detail.png') no-repeat;
                    background-size:cover;
                }
                .withdrawal-log{
                    color:#666;
                    font-size:14px;
                    cursor:pointer;
                    position:absolute;
                    top:24px;
                    right:32px;
                }
                .balance-item{
                    display:flex;
                    flex-direction:column;
                    row-gap:24px;
                    &:nth-child(2){
                        padding:0 56px;
                        border-left:1px solid #e3e3e3;
                        border-right:1px solid #e3e3e3;
                    }
                    .info-title{
                        color:#1f1f1f;
                        font-size:14px;
                    }
                    .info-balance-wrap{
                        display:flex;
                        align-items:center;
                        column-gap:129px;
                        .info-price{
                            color:#1f1f1f;
                            font-size:30px;
                            font-weight:bold;
                        }
                        .btn-box{
                            display:flex;
                            column-gap:10px;
                            // .withdrawal-btn{
                            //     width:92px;
                            //     height:40px;
                            //     line-height:40px;
                            //     text-align:center;
                            //     border:1px solid #ff5967;
                            //     color:#ff5967;
                            //     cursor:pointer;
                            //     border-radius:5px;
                            // }
                            .withdrawal-btn{
                                width:92px;
                                height:40px;
                                background:#ff5967;
                                color:#ffffff;
                                text-align:center;
                                line-height:40px;
                                border-radius:5px;
                                cursor:pointer;
                            }
                        }
                    }
                }
                .balance-info{
                    margin-left:188px;
                    display:flex;
                    flex-direction:column;
                    row-gap:24px;
                    .info-title{
                        color:#1f1f1f;
                        font-size:14px;
                    }
                    .info-balance-wrap{
                        display:flex;
                        align-items:center;
                        column-gap:129px;
                        .info-price{
                            color:#1f1f1f;
                            font-size:30px;
                            font-weight:bold;
                        }
                        .btn-box{
                            display:flex;
                            column-gap:10px;
                            .withdrawal-btn{
                                width:92px;
                                height:40px;
                                line-height:40px;
                                text-align:center;
                                border:1px solid #ff5967;
                                color:#ff5967;
                                cursor:pointer;
                                border-radius:5px;
                            }
                            .charge-btn{
                                width:92px;
                                height:40px;
                                background:#ff5967;
                                color:#ffffff;
                                text-align:center;
                                line-height:40px;
                                border-radius:5px;
                                cursor:pointer;
                            }
                        }
                    }
                    
                }
            }
            .filter-search-container{
                margin-top:30px;
                margin-bottom:25px;
                display:flex;
                align-items:center;
                justify-content:space-between;
                .filter-box{
                    display:flex;
                    align-items:center;
                    column-gap:17px;
                    .filter-label{
                        color:#1a1a1a;
                        font-size:18px;
                        font-weight:bold;
                        margin-right:10px;
                    }
                    .filter-item{
                        padding:10px 25px;
                        color:#666666;
                        font-size:14px;
                        border-radius:5px;
                        background:#f8f9fa;
                        cursor:pointer;
                        &.active{
                            color:#ff5967;
                            background:rgba(255,89,103,0.1);
                        }
                    }
                }
                .search-box{
                    display:flex;
                    align-items:center;
                    column-gap:15px;
                    .search-time-box{
                        background:#f9fafb;
                        border:1px solid #ebebeb;
                        border-radius:8px;
                        width:114px;
                        height:38px;
                        cursor:pointer;
                        .time-dropdown{
                            width:100%;
                            height:38px;
                            display:flex;
                            align-items:center;
                            justify-content:center;
                            column-gap:8px;
                            .time-value{
                                color:#333333;
                                font-size:14px;
                            }
                            .arrow-down-icon{
                                width:16px;
                                height:16px;
                            }
                        }
                    }
                    .search-keyword-box{
                        width:190px;
                        height:38px;
                        border-radius:8px;
                        border:1px solid #e0e0e0;
                        display:flex;
                        align-items:center;
                        justify-content:center;
                        column-gap:10px;
                        overflow:hidden;
                        .search-icon{
                            font-size:22px;
                            padding-left:8px;
                            flex-shrink:0;
                            // margin-right:9px;
                        }
                        .search-input{
                            border:none;
                            outline:none;
                            height:100%;
                            flex:1;
                            min-width:0;
                            margin-right:8px;
                        }
                    }
                }
            }
            table{
                width:100%;
                table-layout:fixed;
                border-collapse: collapse;
                border:1px solid #e0e0e0;
                thead{
                    background:#edeff2;
                }
                thead > tr > th{
                    text-align: center;
                    color:#808080;
                    font-size:14px;
                }
                tr{
                    height:48px;
                }
                tbody > tr{
                    border-bottom:1px solid #ebebeb;
                    &:hover{
                        background:#f5f5f5;
                    }
                    > td{
                        text-align: center;
                        color:#333333;
                        font-size:14px;
                        .order-info{
                            color:#333333;
                            font-size:14px;
                            font-weight:700;
                        }
                        .price-box{
                            font-weight:bold;
                            font-size:14px;
                            &.income{
                                color:#ff5967;
                            }
                            &.pay-out{
                                color:#3bb46d;
                            }
                        }
                    }
                }
            }
            .pagination-container{
                margin-top:20px;
                display:flex;
                justify-content:flex-end;
                align-items:center;
            }
        }
    }
}

.balance-info-box{
    display:flex;
    column-gap:56px;
    margin-left:188px;
}
</style>